import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import usePaymentsStore from 'store/paymentStore';
import usePermissions from 'hooks/usePermissions';
import colors from 'styles/colors';

const styles = {
  tooltipLabel: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer !important',
  },
  tooltipInfo: {
    color: `${colors.text.primary} !important`,
    fontSize: '11px',
  },
};

const UsageChartHeader = () => {
  const { hasPermission } = usePermissions();

  const promoUsage = usePaymentsStore(
    (state) => state.balance.promoUsage,
  );
  const totalUsage = usePaymentsStore(
    (state) => state.usage.totalUsage,
  );

  return (
    <Grid container direction="row" justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography variant="h6" sx={{ color: colors.text.primary }}>
          Usage
        </Typography>
      </Grid>
      {(hasPermission('billing.team.edit') || hasPermission('billing.user')) && (
        <Grid item sx={{ cursor: 'pointer' }}>
          <Tooltip
            arrow
            sx={{ backgroundColor: colors.background.primary }}
            title={(
              <Typography
                sx={styles.tooltipInfo}
              >
                Total Usage:
                {' '}
                {totalUsage}
                {' '}
                $
                <br />
                Promo Used:
                {' '}
                {promoUsage}
                {' '}
                $
              </Typography>
            )}
            placement="right"
          >
            <Box sx={styles.tooltipLabel}>
              <Typography
                variant="cell"
                sx={{
                  color: colors.text.secondary,
                  marginRight: '5px',
                }}
              >
                Credit Usage
              </Typography>
              <InfoOutlinedIcon
                sx={{
                  color: colors.text.secondary,
                  fontSize: '16px',
                }}
              />
            </Box>
          </Tooltip>
        </Grid>
      )}
    </Grid>
  );
};

export default UsageChartHeader;
